import { render, staticRenderFns } from "./releaseNeed.vue?vue&type=template&id=5b3884e6&scoped=true&"
import script from "./releaseNeed.vue?vue&type=script&lang=js&"
export * from "./releaseNeed.vue?vue&type=script&lang=js&"
import style0 from "./releaseNeed.vue?vue&type=style&index=0&id=5b3884e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3884e6",
  null
  
)

export default component.exports